import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    useNavigate
} from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import {
    almacenarAction
} from '../../../../actions/almacenarEjercicioActions';


// css
import {
    ContainerFlex
} from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    PantallaInferencia,
    ContenidoLEN41,
    LecturaLEN41,
    TarjetaTextoLEN41,
    TextoLEN41,
    FraseMarcableLEN41,
    DerechaLEN41,
    PreguntaLEN41,
    RespuestasLEN41,
    RespuestaColorLEN41,
    BottomInferencia
} from '../../../Css/StyledInferencia';


const instrucciones =
    'Leé el texto y elegí la respuesta que mejor responda la pregunta.';

const miniInstrucciones =
    'Leé el texto y elegí la respuesta correcta.';


// =============================================================
// SHUFFLE
// =============================================================

const mezclarOpciones = (array) => {

    const nuevaLista = [
        ...array
    ];

    let currentIndex =
        nuevaLista.length;

    let randomIndex;


    while (
        currentIndex !== 0
    ) {

        randomIndex =
            Math.floor(
                Math.random() *
                currentIndex
            );

        currentIndex--;

        [
            nuevaLista[currentIndex],
            nuevaLista[randomIndex]
        ] = [
            nuevaLista[randomIndex],
            nuevaLista[currentIndex]
        ];
    }


    return nuevaLista;
};


// =============================================================
// SEPARAR TEXTO EN ORACIONES
// =============================================================

const separarOraciones = (texto) => {

    if (!texto) {
        return [];
    }


    const resultado =
        texto.match(
            /[^.!?]+[.!?]+|[^.!?]+$/g
        );


    return (
        resultado ||
        [texto]
    )
        .map(
            frase =>
                frase.trim()
        )
        .filter(Boolean);
};


const LEN41 = () => {

    const dispatch =
        useDispatch();

    const navigate =
        useNavigate();

    const [config] =
        useConfigAuth();


    // =========================================================
    // EJERCICIO
    // =========================================================

    const [
        count,
        setCount
    ] = useState(1);


    const [
        indexes,
        setIndexes
    ] = useState(0);


    const [
        comparar,
        setComparar
    ] = useState(null);


    const [
        opciones,
        setOpciones
    ] = useState([]);


    const [
        seleccionada,
        setSeleccionada
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    // =========================================================
    // ORACIÓN MARCADA
    // =========================================================

    const [
        fraseMarcada,
        setFraseMarcada
    ] = useState(null);


    // =========================================================
    // FEEDBACK
    // =========================================================

    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    // =========================================================
    // ERRORES
    // =========================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    // =========================================================
    // TIEMPOS
    // =========================================================

    const tiemposRef =
        useRef([
            0,
            0,
            0,
            0,
            0
        ]);


    const inicioTiempoRef =
        useRef(null);


    // =========================================================
    // REDUX
    // =========================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const informacion =
        useSelector(
            state =>
                state.informacion.info_DB
        );


    const lista_usada =
        useSelector(
            state =>
                state.informacion.lista_usada
        );


    const lista =
        useSelector(
            state =>
                state.ejercicio.lista
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================
    // SONIDOS
    // =========================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================
    // CONFIGURACIÓN
    // =========================================================

    useEffect(() => {

        dispatch(
            setearEjercicioAction(
                'LEN41'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'lenguaje/inferencia/LEN41-niveles'
            )
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================
    // CARGAR EJERCICIO
    // =========================================================

    useEffect(() => {

        if (
            !Array.isArray(
                informacion
            ) ||
            informacion.length === 0
        ) {

            return;
        }


        setIndexes(
            informacion.length
        );


        const actual =
            informacion[
                count - 1
            ];


        if (!actual) {
            return;
        }


        setComparar(
            actual
        );


        const nuevasOpciones =
            mezclarOpciones([

                {
                    texto:
                        actual.respuesta_1,

                    correcta:
                        true
                },

                {
                    texto:
                        actual.respuesta_2,

                    correcta:
                        false
                },

                {
                    texto:
                        actual.respuesta_3,

                    correcta:
                        false
                }

            ]);


        setOpciones(
            nuevasOpciones
        );


        setSeleccionada(
            null
        );


        setFraseMarcada(
            null
        );


    }, [
        informacion,
        count
    ]);


    // =========================================================
    // INICIAR TIEMPO
    // =========================================================

    useEffect(() => {

        if (
            iniciar &&
            comparar
        ) {

            inicioTiempoRef.current =
                Date.now();
        }


    }, [
        iniciar,
        comparar
    ]);


    // =========================================================
    // REGISTRAR TIEMPO
    // =========================================================

    const registrarTiempoActual = () => {

        if (
            inicioTiempoRef.current ===
            null
        ) {

            return;
        }


        const ahora =
            Date.now();


        const segundos =
            (
                ahora -
                inicioTiempoRef.current
            ) / 1000;


        const indice =
            count - 1;


        tiemposRef.current[
            indice
        ] += segundos;


        inicioTiempoRef.current =
            null;
    };


    // =========================================================
    // MARCAR ORACIÓN
    // =========================================================

    const marcarFrase = (
        indice
    ) => {

        if (
            fraseMarcada === indice
        ) {

            setFraseMarcada(
                null
            );

        } else {

            setFraseMarcada(
                indice
            );
        }
    };


    // =========================================================
    // ELEGIR RESPUESTA
    // =========================================================

    const elegirRespuesta = (
        e,
        opcion,
        indice
    ) => {

        e.preventDefault();


        if (
            disable ||
            !comparar
        ) {

            return;
        }


        setSeleccionada(
            indice
        );


        // =====================================================
        // CORRECTA
        // =====================================================

        if (
            opcion.correcta
        ) {

            setDisable(
                true
            );


            registrarTiempoActual();


            setIsCorrect(
                true
            );


            GoodWork();


            setTimeout(() => {

                setIsCorrect(
                    false
                );

            }, 300);


            if (
                count < indexes
            ) {

                setTimeout(() => {

                    setSeleccionada(
                        null
                    );


                    setFraseMarcada(
                        null
                    );


                    setCount(
                        valor =>
                            valor + 1
                    );


                    setDisable(
                        false
                    );

                }, 500);

            } else {

                setTimeout(() => {

                    dispatch(
                        finalizarEjercicioAction()
                    );

                }, 1000);
            }


            return;
        }


        // =====================================================
        // INCORRECTA
        // =====================================================

        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        setContarErrores(
            valor =>
                valor + 1
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );

        }, 300);


        setTimeout(() => {

            setSeleccionada(
                null
            );


            setDisable(
                false
            );

        }, 800);
    };


    // =========================================================
    // GUARDAR
    // =========================================================

    useEffect(() => {

        if (!finalizar) {

            return;
        }


        const tiempoFinal =
            tiemposRef.current.map(
                tiempo =>
                    Math.round(
                        tiempo * 10
                    ) / 10
            );


        const informacionGuardar = {

            config,

            payload: {

                ejercicio:
                    'LEN41',

                errores:
                    contarErrores,

                tiempo:
                    tiempoFinal,

                id_paciente,

                lista_usada,

                lista,

                sesion

            }

        };


        dispatch(
            almacenarAction(
                informacionGuardar
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        finalizar
    ]);


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <Fragment>


            <HeaderEjercicios
                estrellas={true}
                carrito={true}
            />


            {
                iniciar

                    ? (

                        <PantallaInferencia>


                            <ContenidoLEN41>


                                <ContainerFlex

                                    width="100%"

                                    display="flex"

                                    justify="center"

                                    align="center"

                                    isCorrect={
                                        isCorrect
                                    }

                                    isIncorrect={
                                        isIncorrect
                                    }

                                    $mantengoMay={
                                        true
                                    }

                                >


                                    {
                                        comparar && (

                                            <LecturaLEN41>


                                                {/* ======================= */}
                                                {/* TEXTO                   */}
                                                {/* ======================= */}

                                                <TarjetaTextoLEN41>


                                                    <TextoLEN41>


                                                        {
                                                            separarOraciones(
                                                                comparar.frase
                                                            ).map(
                                                                (
                                                                    frase,
                                                                    indice
                                                                ) => (

                                                                    <Fragment
                                                                        key={
                                                                            indice
                                                                        }
                                                                    >


                                                                        <FraseMarcableLEN41

                                                                            type="button"

                                                                            $marcada={
                                                                                fraseMarcada ===
                                                                                indice
                                                                            }

                                                                            onClick={
                                                                                () =>
                                                                                    marcarFrase(
                                                                                        indice
                                                                                    )
                                                                            }

                                                                        >

                                                                            {
                                                                                frase
                                                                            }

                                                                        </FraseMarcableLEN41>


                                                                        {' '}


                                                                    </Fragment>

                                                                )
                                                            )
                                                        }


                                                    </TextoLEN41>


                                                </TarjetaTextoLEN41>


                                                {/* ======================= */}
                                                {/* PREGUNTA + RESPUESTAS   */}
                                                {/* ======================= */}

                                                <DerechaLEN41>


                                                    <PreguntaLEN41>

                                                        {
                                                            comparar.pregunta
                                                        }

                                                    </PreguntaLEN41>


                                                    <RespuestasLEN41>


                                                        {
                                                            opciones.map(
                                                                (
                                                                    opcion,
                                                                    indice
                                                                ) => (

                                                                    <RespuestaColorLEN41

                                                                        key={
                                                                            `${comparar.id}-${indice}`
                                                                        }

                                                                        type="button"

                                                                        disabled={
                                                                            disable
                                                                        }

                                                                        $seleccionada={
                                                                            seleccionada ===
                                                                            indice
                                                                        }

                                                                        onClick={
                                                                            e =>
                                                                                elegirRespuesta(
                                                                                    e,
                                                                                    opcion,
                                                                                    indice
                                                                                )
                                                                        }

                                                                    >

                                                                        <span />

                                                                        {
                                                                            opcion.texto
                                                                        }

                                                                    </RespuestaColorLEN41>

                                                                )
                                                            )
                                                        }


                                                    </RespuestasLEN41>


                                                </DerechaLEN41>


                                            </LecturaLEN41>

                                        )
                                    }


                                </ContainerFlex>


                            </ContenidoLEN41>


                            <BottomInferencia>


                                <BotoneraBottom
                                    miniInstrucciones={
                                        miniInstrucciones
                                    }
                                />


                            </BottomInferencia>


                        </PantallaInferencia>

                    )

                    : (

                        <Instrucciones
                            instrucciones={
                                instrucciones
                            }
                        />

                    )
            }


        </Fragment>
    );
};


export default LEN41;